<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wTzyQ6/tc-custom/9781481477062.jpg?1730522513284" alt="This image is the cover for the book Peculiar Incident on Shady Street"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Peculiar Incident on Shady Street
      </h1>
      <p class="bookDescription body article font2">
        <b>A girl unravels a centuries-old mystery after moving into a haunted house in this deliciously suspenseful read that <i>Kirkus Reviews </i>calls “just the ticket for a cold autumn night.”</b><br/><br/>Tessa Woodward isn’t exactly thrilled to move to rainy, cold Chicago from her home in sunny Florida. But homesickness turns to icy fear when unexplainable things start happening in her new house. Things like flickering lights, mysterious drawings appearing out of nowhere, and a crackling noise she can feel in her bones.<br/><br/>When her little brother’s doll starts crying real tears, Tessa realizes that someone—or something—is trying to communicate with her. And it involves a secret that’s been shrouded in mystery for more than one hundred years.<br/><br/>With the help of three new friends, Tessa begins unraveling the mystery of what happened in the house on Shady Street—and more importantly, what it has to do with her!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lindsay Currie
      </h2>
      
      <p class="authorDescription body article">Lindsay Currie&#160;lives in Chicago, Illinois, with one incredibly patient hubby, three amazing kids, and a 160-pound lap dog named Sam. She&rsquo;s fond of tea, Halloween, Disney World, and things that go bump in the night!</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Aladdin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5d65ec7c